import { Button, DialogActions, Grid, Typography } from "../../../../components";
import { formatCnpj } from "../../../../utils";

export function CadastrarTransportadoraStep({
  transportadora,
  setTransportadora,
  cadastrarTransportadora,
}) {

  return (
    <>
    <Grid container spacing={2}>
      <Grid item xs={7}>
        {transportadora?.nomeRazaoSocial ? (
          <Typography variant="overline">
            Nome da Transportadora:
            <h5 style={{ fontWeight: 800, margin: 0 }}>
              {transportadora.nomeRazaoSocial}
            </h5>
            <br />
          </Typography>
        ) : null}
      </Grid>
      <Grid item xs={5}>
        {transportadora?.cnpjCpf ? (
          <Typography variant="overline">
            CNPJ:
            <h5 style={{ fontWeight: 800, margin: 0 }}>
              {formatCnpj(transportadora.cnpjCpf)}
            </h5>
          </Typography>
        ) : null}
      </Grid>
    </Grid>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="overline">
          {transportadora?.endereco?.localEmbarque ? (
            <>
              Endereço:
              <h6 style={{ fontWeight: 800, margin: 0 }}>
                {transportadora.endereco.localEmbarque}
              </h6>
            </>
          ) : null}
        </Typography>
      </Grid>
    </Grid>
    <DialogActions className="d-flex align-items-center justify-content-center mt-3 mb-2">
      <Button 
        variant="contained" 
        color="padrao" 
        startIcon={
          <i
            className="ph-fill ph-caret-left"
            style={{ color: "#000", fontSize: 18 }}
          ></i>
        }
        onClick={() => setTransportadora(null)}
      >
        Voltar
      </Button>
      <Button
          variant="contained"
          color="success"
          onClick={cadastrarTransportadora}
          endIcon={
              <i
                className="ph-fill ph-caret-right"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
          }
        >
          Cadastrar
        </Button>
    </DialogActions>
    </>
  )
}